import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Umbrella({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.9999 1.33331C6.10888 1.33331 1.33325 6.10894 1.33325 12H2.66659C2.66659 10.5272 3.86049 9.33331 5.33325 9.33331C6.80601 9.33331 7.99992 10.5272 7.99992 12H9.33325C9.33325 10.7574 10.1831 9.71335 11.3333 9.41733V20C11.3333 21.4727 12.5272 22.6666 13.9999 22.6666C15.4727 22.6666 16.6666 21.4727 16.6666 20V19.3333H15.3333V20C15.3333 20.7364 14.7363 21.3333 13.9999 21.3333C13.2635 21.3333 12.6666 20.7364 12.6666 20V9.41733C13.8167 9.71335 14.6666 10.7574 14.6666 12H15.9999C15.9999 10.5272 17.1938 9.33331 18.6666 9.33331C20.1393 9.33331 21.3333 10.5272 21.3333 12H22.6666C22.6666 6.10894 17.891 1.33331 11.9999 1.33331ZM5.33325 7.99998C4.60341 7.99998 3.91921 8.19545 3.33017 8.53689C4.7055 5.09688 8.0689 2.66665 11.9999 2.66665C15.9309 2.66665 19.2943 5.09688 20.6697 8.53689C20.0806 8.19545 19.3964 7.99998 18.6666 7.99998C17.2753 7.99998 16.0499 8.71032 15.3333 9.78812C14.6166 8.71032 13.3912 7.99998 11.9999 7.99998C10.6086 7.99998 9.3832 8.71032 8.66659 9.78812C7.94997 8.71032 6.72457 7.99998 5.33325 7.99998Z"
        fill={iconColor}
      />
    </Svg>
  );
}
